import { ArrowUpIcon, ArrowDownIcon, EqualsIcon } from "@heroicons/react/20/solid";

const CompareBadge = ({
  base,
  amended,
  compact = false,
}: {
  base?: number | null;
  amended?: number | null;
  compact?: boolean;
}) => {
  if (base == null || amended == null) return <span className="text-xs text-gray-400">—</span>;

  const diff = amended - base;
  const abs = Math.abs(diff);

  if (abs < 0.005) {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-700 ring-1 ring-gray-200">
        <EqualsIcon className="h-3.5 w-3.5" />
        {compact ? "Same" : "Same"}
      </span>
    );
  }

  const higher = diff > 0;

  return (
    <span
      className={
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ring-1 " +
        (higher
          ? "bg-green-50 text-green-700 ring-green-200"
          : "bg-red-50 text-red-700 ring-red-200")
      }
      title={`${higher ? "Higher" : "Lower"} by £${abs.toFixed(2)}`}
    >
      {higher ? <ArrowUpIcon className="h-3.5 w-3.5" /> : <ArrowDownIcon className="h-3.5 w-3.5" />}
      {compact ? `£${abs.toFixed(2)}` : (
        <>
          {higher ? "Higher" : "Lower"} <span className="opacity-80">£{abs.toFixed(2)}</span>
        </>
      )}
    </span>
  );
};

export default CompareBadge;